import CostBreakdownSelector from '../CostBreakdownSelector';
import CostBreakdownInput from '../CostBreakdownInput';

const CBInvoiceItemDetailsPercentage = ({ newItem, options, updateState }) => {
  return (
    <div className='flex flex-col md:flex-row gap-4'>
      <div className='flex w-full md:w-1/2'>
        <CostBreakdownSelector
          value={newItem.name}
          options={Object.keys(options)}
          placeholder='Product / Service'
          onChange={e => {
            updateState(e, 'name');
          }}
        />
      </div>

      <div className='flex flex-col md:flex-row items-end w-full md:w-1/2 gap-4'>
        <CostBreakdownInput
          value={newItem.price}
          placeholder='Percent'
          disabled={false}
          onChange={e => {
            updateState(e, 'price');
          }}
          isPercentage
        />

        <CostBreakdownInput value='N/A' placeholder='Total' disabled />
      </div>
    </div>
  );
};

export default CBInvoiceItemDetailsPercentage;
